import { Middleware, configureStore, combineReducers } from '@reduxjs/toolkit';

import { mockApi } from './api/mock';
import { citiesApi } from './api/cities';
import { loaderReducer } from './slices/loader';
import { types, authReducer } from './slices/auth';
import { appointmentApi } from './api/appointments';

const apis = [mockApi, citiesApi, appointmentApi];

const appReducer = combineReducers({
  ...Object.fromEntries(apis.map((api) => [api.reducerPath, api.reducer])),
  auth: authReducer,
  loader: loaderReducer,
});

export const resetApiState = (dispatch: any) => {
  apis.map((api) => dispatch(api.util.resetApiState()));
};

const rootReducer = (state: any, action: any) => {
  if (action.type === types.logout) {
    return appReducer(undefined, action);
  }
  return appReducer(state, action);
};

const middlewares: Middleware[] = apis.map((api) => api.middleware);

export const store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(middlewares),
});

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
